import React,{useState} from "react";
import css from "./FieldView.module.css";
import FieldHeader from "./FieldHeader/FieldHeader";
import FieldBody from "./FieldBody/FieldBody";
import {Accordion} from "react-vritra";


export default function FieldView(props){
    const {field}=props,{name}=field;
    const [open,setOpen]=useState(false);
    const subfields=field.props||field.overloads;
    const asAccordion=subfields?.length>3;
    return asAccordion?
        <Accordion
            id={name} open={open}
            className={css.fieldview}
            headerClassName={css.header} 
            renderHeader={({open})=><>
                <div className={css.bordertop}/>
                <FieldHeader field={field} openable={true} open={open}/>
            </>}
            renderContent={()=><FieldBody field={field}/>}
            onOpen={()=>{setOpen(true)}}
            onClose={()=>{setOpen(false)}}
        />
    :(
        <div id={name} className={css.fieldview}>
            <div className={css.bordertop}/>
            <FieldHeader className={css.header} field={field}/>
            {withBody(field)&&<FieldBody field={field}/>}
        </div>
    )
}


const headerKeys=["name","type","defaultValue","required"];
const withBody=(field)=>{
    return Object.keys(field).some(key=>!headerKeys.includes(key)&&field[key]);
}
